import styled from 'src/style';
import { Paragraph } from '../../Typography/index';
import { mediaQueries } from 'src/style/breakpoints';
import colors from 'src/style/colors';

export const DayTitle = styled(Paragraph.withComponent('span'))({
  fontWeight: 'bold',
  fontSize: 19,
  lineHeight: '24px',
  padding: 0,
});

export const DayText = styled(Paragraph)({
  fontSize: 16,
  lineHeight: '25px',
  padding: 0,
  paddingTop: 5,
  [mediaQueries.tabletLandscapeUp]: {
    paddingTop: 10,
  },
  [mediaQueries.phoneOnly]: {
    fontSize: 16,
    lineHeight: '20px',
  },
});

export const DayPart = styled.div({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  textAlign: 'left',
  paddingRight: 30,
  marginTop: 0,
  marginBottom: 50,
  letterSpacing: 0.5,
  [mediaQueries.tabletLandscapeUp]: {
    marginTop: 50,
    marginBottom: 0,
  },
});

export const Hours = styled.div({
  color: colors.yellow,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  fontWeight: 'bold',
  padding: 0,
  marginBottom: 8,
  letterSpacing: 1,
  [mediaQueries.tabletLandscapeUp]: {
    transform: 'rotate(-17deg)',
    marginBottom: 50,
    marginLeft: '-10px',
  },
  [mediaQueries.desktopUp]: {
    transform: 'rotate(-17deg)',
    marginBottom: 55,
    marginLeft: '-10px',
  },
});
